export default {
    projects: [
        {
        title: "Age Calculator",
        desc: "A installable, offline app that calculates age from date of birth",
        link: "https://navin77.gitlab.io/ac/",
        },
        {
            title: "Orthographic Visualizer",
            desc: `A 3d playground where you can view a 3d model in orthographic projections.
                   Useful for: students studying engineering graphics`,
            link: "https://navin77.gitlab.io/ov/",
        }
    ]
} 